
  import { defineComponent, PropType } from 'vue';

  import Loader from '@/components/Loader.vue';

  import { TDashboardsRatingItem } from '../../../types/regionDashboards';

  type TPreparedRatingItem = Omit<TDashboardsRatingItem, 'position'> & { position: string | number };

  export default defineComponent({
    name: 'RegionDashboardsRatingList',
    components: {
      Loader,
    },
    props: {
      ratingList: {
        type: Object as PropType<TDashboardsRatingItem[]>,
        required: true,
      },
      currentItemId: {
        type: Number,
        required: true,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      placeMode: {
        type: String,
        default: 'default',
        validator: (value: string) => ['default', 'soft'].includes(value),
      },
    },
    computed: {
      isShowFirstEllipsis() {
        return this.ratingList[1].realPosition > 2;
      },
      isShowLastEllipsis() {
        return (
          this.ratingList[this.ratingList.length - 1].realPosition - 1 >
          this.ratingList[this.ratingList.length - 2].realPosition
        );
      },
      getPreparedRatingList(): TPreparedRatingItem[] {
        if (this.ratingList.length === 0) return [];

        const firstItem = this.ratingList[0];
        const lastItem = this.ratingList[this.ratingList.length - 1];
        const itemWithEllipsis: TPreparedRatingItem = {
          id: -1,
          name: '...',
          position: '...',
          realPosition: -1,
        };

        let preparedList: TPreparedRatingItem[] = [firstItem];

        if (this.isShowFirstEllipsis) {
          preparedList = [...preparedList, itemWithEllipsis];
        }

        preparedList = [...preparedList, ...this.ratingList.slice(1, this.ratingList.length - 1)];

        if (this.isShowLastEllipsis) {
          preparedList = [...preparedList, itemWithEllipsis];
        }

        preparedList = [...preparedList, lastItem];

        if (this.placeMode === 'soft') {
          preparedList = this.getSoftRatingList(preparedList);
        }

        return preparedList;
      },
    },
    methods: {
      getSoftRatingList(list: TPreparedRatingItem[]): TPreparedRatingItem[] {
        return list.map((item, index) => {
          if (!index) return item;

          const prevItem = list[index - 1];

          return {
            ...item,
            position: item.position === prevItem.position ? '' : item.position,
          };
        });
      },
    },
  });
